import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import LayoutPortal from "./layouts/Portal.vue";
import Home from "./views/Home.vue";

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:locale",
      name: "home",
      meta: {
        layout:
          window.location.hostname !== "obuv.info"
            ? LayoutPortal
            : () => import("./layouts/App.vue")
      },
      component:
        window.location.hostname !== "obuv.info"
          ? Home
          : () => import("./views/Landing.vue")
    },
    {
      path: "/:locale/account",
      name: "account",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/Profile.vue")
    },
    {
      path: "/:locale/cart",
      name: "cart",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/Cart.vue")
    },
    {
      path: "/:locale/account/profile-edit",
      name: "profile-edit",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/ProfileEdit.vue")
    },
    {
      path: "/:locale/about",
      name: "about",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/About.vue")
    },
    {
      path: "/:locale/partners",
      name: "partners",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/Partners.vue")
    },
    {
      path: "/:locale/partners/:id",
      name: "partner",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/PartnersMore.vue")
    },
    {
      path: "/:locale/news",
      name: "news",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/News.vue")
    },
    {
      path: "/:locale/news/:id",
      name: "new",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/New.vue")
    },
    {
      path: "/:locale/info/:uri",
      name: "info",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/InfoPage.vue")
    },
    {
      path: "/:locale/items/:id",
      name: "product",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/Item.vue")
    },
    {
      path: "/:locale/:catUri",
      name: "category",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/Category.vue")
    },
    {
      path: "/:locale/pages/:uri",
      name: "pages",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/InfoPage.vue")
    },
    {
      path: "/:locale/:catUri/:uri",
      name: "sub-cat",
      meta: {
        layout: LayoutPortal
      },
      component: () => import("./views/Category.vue")
    }
  ],
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});
